// "Sorgula"ya basıldığında aktif e-Fatura entegrasyonu yoksa: ne gerektiği ve nasıl ekleneceği.
import React from 'react';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTranslation } from 'react-i18next';
import { L } from './fields';

export const E_INVOICE_PAGE = '/e-fatura';

const Step: React.FC<{ n: number; children: React.ReactNode }> = ({ n, children }) => (
  <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
    <Box
      sx={{
        flex: 'none', width: 24, height: 24, borderRadius: '50%', bgcolor: 'primary.main', color: 'primary.contrastText',
        display: 'grid', placeItems: 'center', fontSize: 13, fontWeight: 700,
      }}
    >
      {n}
    </Box>
    <Typography variant="body2" sx={{ pt: 0.25 }}>{children}</Typography>
  </Box>
);

export const NoIntegrationDialog: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  const { t } = useTranslation('accounting');
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>
        {t(`${L}.lookup.noIntegrationTitle`, 'e-Fatura entegrasyonu gerekli')}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t(`${L}.lookup.noIntegrationText`, 'Mükellef sorgusu, firmanızın e-Fatura entegratörü üzerinden yapılır. Henüz aktif bir entegrasyon tanımlı değil. Eklemek için:')}
        </Typography>
        <Box sx={{ display: 'grid', gap: 1.5 }}>
          <Step n={1}>{t(`${L}.lookup.step1`, 'Sol menüden E-Fatura sayfasını açın.')}</Step>
          <Step n={2}>{t(`${L}.lookup.step2`, 'Sağ üstteki ⋮ (Diğer) menüsünden "Entegrasyon Ayarları"nı seçin.')}</Step>
          <Step n={3}>{t(`${L}.lookup.step3`, 'Entegratörünüzü (QNB eFinans, EDM, PavoPay…) seçip kullanıcı bilgilerini girin ve aktif yapın.')}</Step>
          <Step n={4}>{t(`${L}.lookup.step4`, 'Bu pencereye dönüp tekrar "Sorgula"ya basın.')}</Step>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
          {t(`${L}.lookup.noIntegrationNote`, 'Entegrasyon olmadan da cariyi kaydedebilirsiniz; yalnız sorgu ve otomatik unvan çalışmaz.')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('current.actions.close')}</Button>
        <Button
          variant="contained"
          endIcon={<OpenInNewIcon fontSize="small" />}
          onClick={() => window.open(E_INVOICE_PAGE, '_blank', 'noopener')}
        >
          {t(`${L}.lookup.openEInvoice`, 'E-Fatura sayfasını aç')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
